import { DeleteConfirmDialog } from "@sd/components/common/DeleteConfirmDialog";

interface DeleteTicketConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ticketLabel: string;
  ticketRef?: string;
  onConfirm: () => void | Promise<void>;
  confirming?: boolean;
}

export function DeleteTicketConfirmDialog({
  open,
  onOpenChange,
  ticketLabel,
  ticketRef,
  onConfirm,
  confirming = false,
}: DeleteTicketConfirmDialogProps) {
  return (
    <DeleteConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete this ticket?"
      description="This action is permanent and cannot be undone. The ticket will be removed from all queues and reports."
      itemCaption="Ticket subject"
      itemRef={ticketRef}
      itemLabel={ticketLabel}
      warningMessage="Assignments, status history, and linked data for this ticket may also be deleted."
      confirmButtonLabel="Delete ticket"
      onConfirm={onConfirm}
      confirming={confirming}
    />
  );
}
